import {
  setupEventListeners,
} from '@tracking/components/handlers';
import { setupEventTrackers } from '@tracking/components/setupTracker';
import { initializeFallback } from '@tracking/components/gtmFallback';
import { initializeAbTestTracking } from '@common/utils/abTestTracking';
import { isScaler } from '@common/utils/environment';

function initialize() {
  window.dataLayer = window.dataLayer || [];

  window.GTMContext = {};
  setupEventTrackers();
  initializeAbTestTracking();

  window.TrackingHelper.setContext('user_data', {
    cu_user_type: window.GTMData?.userType !== ''
      ? window.GTMData?.userType : undefined,
    cu_free_mentee: window.GTMData?.freeMentee,
  });

  document.addEventListener('initializedGTM', () => {
    window.GTMtracker.trackEvent('pageViewFormatter', {
      location: window.location,
    });

    const gtmDataLayerVariables = window.GTMData?.gtmDataLayerVariables ?? [];
    const gtmServerEvents = window.GTMData?.gtmServerEvents ?? [];

    gtmDataLayerVariables.forEach((ele) => {
      window.TrackingHelper?.pushToGTM(ele);
    });

    gtmServerEvents.forEach((ele) => {
      const {
        event, action, data, label,
      } = ele;
      const eventData = window.GTMtracker.getGTMEventData(
        event, action, data, label,
      );
      window.GTMtracker.clearAttributes();
      window.TrackingHelper?.pushToGTM(eventData);
    });
    setupEventListeners();

    if (!window.google_tag_manager && isScaler()) {
      initializeFallback();
    }
  });

  window.addEventListener('message', (e) => {
    const { origin } = e;
    if (origin.includes('scaler.com') || origin.includes('interviewbit.com')) {
      try {
        const { data } = e;
        const decoded = JSON.parse(data);
        if (decoded?.event) {
          window.dataLayer.push(decoded);
        }
      } catch (err) {
        // console.log(err);
      }
    }
  });
}

initialize();
